// Unpublished Work © 2022-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {DatePicker, TextField} from '@deere/isg.component-library';
import {useDeepEffect} from 'Utils/react-utils';
import moment from 'moment';
import dayjs from 'dayjs';

function isValidDate(date, required) {
    const selectedDate = moment(date);
    const isValidDate = Boolean(date) && selectedDate.isValid();

    return isValidDate || !required;
}

function isValidRange([
    from, to
], required) {
    const isValidFrom = isValidDate(from, required);
    const isValidTo = isValidDate(to, required);

    return isValidFrom && isValidTo;
}

function ValidationDate(props) {
    const {
        component: Component = DatePicker,
        setValid,
        range,
        required,
        readOnly,
        value,
        ...inputProps
    } = props;

    const {
        name,
        label,
        dateFormat
    } = inputProps;

    useDeepEffect(() => {
        const valid = range ? isValidRange(value, required) : isValidDate(value, required);

        setValid(name, valid);

        return () => {
            setValid(name, true);
        };
    }, [value, required]);

    const component = (
        <div className={props.className || ''}>
            {range ? <Component
                label={label || ''}
                {...inputProps}
            /> : <Component
                label={label || ''}
                value={value ? dayjs(value).toDate() : null}
                {...inputProps}
            />}
        </div>
    );

    if (readOnly) {
        return (
            <TextField
                disabled={readOnly}
                label={label}
                tabIndex={0}
                type='text'
                value={value && dayjs(value).format(dateFormat)}
            />
        );
    }

    if (required) {
        return (
            <div className='required-input'>
                {component}
            </div>
        );
    }

    return component;
}

ValidationDate.propTypes = {
    className: PropTypes.string,
    component: PropTypes.elementType,
    name: PropTypes.string.isRequired,
    range: PropTypes.bool,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
    selected: PropTypes.object,
    setValid: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ])

};

export default ValidationDate;
